module.exports = __webpack_public_path__ + "img/Orbiting-4-mobile.8932f473.png";